import tree from '../state';
import * as siteSearchService from '../services/siteSearchService';

export const enterSiteSearchAction = ({ params, location }, replace, callback) => {
    tree.set('loading', true);
    const q = location.query;
    siteSearchService.getSiteSearchResults(q).then(siteSearch => {
        tree.set('siteSearch', siteSearch);
        tree.set('loading', false);
        callback();
    }).catch(err => {
		if (err.status === 404) {
			tree.set('siteSearch', null);
			tree.set('loading', false);
			callback(); // eslint-disable-line callback-return
		}
		callback(err);
	});
};



// WEBPACK FOOTER //
// ./src/actions/siteSearchActions.js